import * as XLSX from 'xlsx';

/**
 * Genera y descarga un archivo de Excel a partir de un conjunto de datos JSON.
 *
 * @param data Array de objetos que representan los datos a incluir en Excel.
 * @param sheet El nombre que se asignará a la hoja de cálculo dentro del libro de Excel.
 *
 * @example
 * const sampleData = [
 *   { name: "Alice", age: 24, job: "Engineer" },
 *   { name: "Bob", age: 29, job: "Designer" }
 * ];
 * const sheetName = "Employees";
 * downloadExcelUseCase(sampleData, sheetName); // Esto generará y descargará "Employees.xlsx".
 *
 * @remarks
 * Esta función utiliza la biblioteca `xlsx` para manejar la creación y manipulación de archivos de Excel.
 * Asegúrese de que esta función se ejecute en un entorno que permita la descarga de archivos, como un navegador web.
 */

const useDownloadExcel = () => {
  const download = <T extends object>(
    data: T[], 
    sheet: string, 
    columnTranslations: Record<string, string>
  ) => {
    if (!data.length) {
      console.warn("No data.");
      return;
    }

    // Transformar las claves del objeto a los nombres traducidos
    const translatedData = data.map((row) => {
      const newRow: Record<string, any> = {};
      Object.keys(row).forEach((key) => {
        const translatedKey = columnTranslations[key] || key; // Si no hay traducción, usa la clave original
        newRow[translatedKey] = row[key as keyof T];
      });
      return newRow;
    });

    const ws = XLSX.utils.json_to_sheet(translatedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheet);
    XLSX.writeFile(wb, `${sheet}.xlsx`);
  };

  return { download };
};
export default useDownloadExcel;
